import React from 'react';

import isArchived from 'archive/isArchived';
import sortRequestTaskSchemas from 'requests/schemas/sortRequestTaskSchemas';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import AddIcon from 'ui-library/icons/AddIcon';
import Menu from 'ui-library/menus/Menu';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';

interface AddTaskSchemaDropdownProps {
  requestTaskSchemaIds: Array<string>;
  requestTaskSchemasById: Record<string, RequestTaskSchemaGraphQL>;
  onSelectSchema: (taskSchema: RequestTaskSchemaGraphQL) => void;
}

interface State {
  taskSchemaId: string | null;
}

export default class AddTaskSchemaDropdown extends React.Component<AddTaskSchemaDropdownProps, State> {
  override state: State = {
    taskSchemaId: null,
  };

  _handleSelectSchema = (taskSchemaId: string): void => {
    const selectedSchema = this.props.requestTaskSchemasById[taskSchemaId];
    this.setState({taskSchemaId});
    this.props.onSelectSchema(selectedSchema);
  };

  _getValidSchemasForNewTask(): Array<RequestTaskSchemaGraphQL> {
    return this.props.requestTaskSchemaIds
      .map((id) => this.props.requestTaskSchemasById[id])
      .filter((schema) => !isArchived(schema));
  }

  _getTaskSchemaOptionDatas(): Array<{name: string; value: string}> {
    const requestTaskSchemas = sortRequestTaskSchemas(this._getValidSchemasForNewTask());
    return requestTaskSchemas.map((taskSchema) => ({name: taskSchema.name, value: taskSchema.id}));
  }

  override render(): JSX.Element {
    return (
      <Dropdown
        menu={
          <SearchableMenu
            height={Menu.HEIGHTS.MEDIUM}
            onSelect={this._handleSelectSchema}
            optionDatas={this._getTaskSchemaOptionDatas()}
            selectedValue={this.state.taskSchemaId}
            width={Menu.WIDTHS.XLARGE}
          />
        }
      >
        <AddIcon dataTestAttrs={{component: 'AddTaskSchemaDropdown', element: 'addIcon'}} />
      </Dropdown>
    );
  }
}
